import React, { Component } from "react";
import MoreInfo from "./MoreInfo";
import { Slide } from "react-awesome-reveal";

class About extends Component {
  constructor(props){
    super(props);
    this.state = {
      show: false,
    }
  }

  ShowMore = () =>{
    if(this.state.show === false){
      this.setState(() => ({
        show: true,
      }));
     }
     else
     {
        this.setState(() => ({
          show: false,
        }));
      }
  }
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = "images/" + this.props.sharedBasicInfo.image2;
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
    }

    return (
      <section class="about" id="about">
        <Slide direction="up">
              <div className="about-img">
                  <img
                    src={profilepic}
                    alt="Avatar placeholder"
                  />
              </div>
            </Slide>
              <div class="about-content">
                <h2 class="heading">About <span>Me</span></h2>
                <h3><span className="wave">{hello} :) </span></h3>
                    <p>{about}</p>
                    <MoreInfo/>
                    {/* <button class="btn" style={{cursor:"pointer"}} onClick={this.ShowMore()}>{this.state.show ? "Read More" : "Close"}</button> */}
              </div>
             
      </section>
    );
  }
}

export default About;
